<template>
  <div>
    <!-- second_none 指的是收起的二级评论  && (!item.addSecondData)  -->
    <li 
        :class="['dy_secItem22',(ckind == 'second' && item.old_i > (2 - 1) ) ? 'second_none' :'']" 
        v-for="(item,i) in data"
        :key="item.id"
        :data-test="item.old_i"
      >
      <div class="sec_wrap22">
        <a  class="second_reply_img22 js-page-person" href="javascript:;"
          @click.stop.prevent="
            srH5CallNativeMethodApp('call_Native',{
              kind: 'person_page',//跳转页面
              id:item.role == 'liver'? item.l_id : item.u_id,
              o_kind:item.role == 'liver'? 'live_msg' : 'user_msg',
            })"
          >
          <img
               :src="item.u_avatar">
        </a>
        <div :class="['second_reply_right22']">


          <div class="dy_warp_hover" 
            @click.stop.prevent="
                  srH5CallNativeMethodApp('comment_input',{
                    comment:item,
                    i:i,
                    j:ci == undefined ? -1 : ci,
                    kind:'comment',
                  })">

          <div class="dy_secComWrap">
            <p class="dy_secCom22 ">
              <a href="javascript:;"
                :data-id="item.u_id" class="js-page-person2">{{card_user.remark_name || item.u_name}}</a>
              <span style="color: #fe484a;" v-if="(item.is_water && item.is_water == 1)">(灌水)</span>
              <em v-for="em in item.user_medals_tail"
                  :style="{backgroundImage:'url('+em.image+')'}"
                  :title="em.title"
                  :key="em.title"
                  @click.stop.prevent="srH5CallNativeMethodApp('call_Native',{
                    kind:'medal_page',
                    url:`https://apis.aigupiao.com/MedalSystem/index/u_id/${item.u_id}/version/1160`,
                  })"
              ></em>
  
              <!-- 作者信息 -->

              <template v-if="card_user_info">
                <span class="card_author" v-if="(card_user_info.l_id === item.l_id)">作者</span>
              </template>


              <!-- 置顶评论 -->
              <span v-if="(item.is_user_set_top)" class="is_user_set_top">置顶评论</span>

            </p>
            <div class="dy_second_manage" 
              @click.stop.prevent="srH5CallNativeMethodApp('comment_options',{
                    data:item,
                    i:i,
                    j:ci == undefined ? -1 : ci,
                    comment_num:item.comment_num == undefined ? -1 : item.comment_num,
                    comment_origin_content:cdata ? cdata : '',
                  })">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="3" viewBox="0 0 15 3" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5ZM9 1.5C9 2.32843 8.32843 3 7.5 3C6.67157 3 6 2.32843 6 1.5C6 0.671573 6.67157 0 7.5 0C8.32843 0 9 0.671573 9 1.5ZM13.5 3C14.3284 3 15 2.32843 15 1.5C15 0.671573 14.3284 0 13.5 0C12.6716 0 12 0.671573 12 1.5C12 2.32843 12.6716 3 13.5 3Z" fill="#DDDDDD"/>
              </svg>
            </div>


          </div>

          <p
            :class="['content_css',apptextSize]"
            :id="'comment_content'+item.id+ckind">
            
            <span v-if="item.image" class="cmtImg"
              @click.stop.prevent="srBrowserMedia(item.image)"
               >查看图片
            </span>
            
            <span class="dy_secTim22" v-html="a_link(item)" 
              @click.stop.prevent="clickHandle($event,item,i,ci)"></span>
            


            <!--展开收起全文-->
            <a
              v-show="0"
              :id="'expand_full_js'+item.id+ckind"
              href="javascript:;"
              @click.stop.prevent="expand(item.id,1)"
              class="expand_full22 expand_full_js">
              ...全文
            </a>
            <a
              v-show="0"
              :id="'expand_full_js_sq'+item.id+ckind"
              href="javascript:;"
              @click.stop.prevent="expand(item.id,0)"
              class="expand_full22 expand_none_js">
              收起
            </a>


          </p>

          <p v-show="0"
            :class="['content_css','content_css_less_line',apptextSize]"
            >
            测试行高数据
          </p>




          <div class="anthor_zan"  v-if="item.is_author_support == 1">
            作者赞过
          </div>

          <div class="dy_secComWrap">
            <p class="dy_secCom22">
  

              <!-- 评论时间 -->
              <span class=" dy_secTim22_ip">{{ timeStampFn(item) }}</span>

              <!-- 评论ip -->
              <span v-show="item.from_province " class=" dy_secTim22_ip">来自{{item.from_province && item.from_province.split && item.from_province.split('来自')[1]}}</span>

              <span v-if="item.is_hot_comment == 1" class=" dy_secTim22_ip hot">热评</span>

            </p>


            <div class="dy_second_manage">

              <!--点赞-->
              <div class="comment_info_reply22">

                <a href="javascript:;" :id="item.id" :class="['v2_dy_support', {done: item.is_support == 'yes'}]" @click.stop.prevent="sup(item.id, i,item.is_support)">
                  <svg v-show="item.is_support == 'no'" xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path d="M6.50828 8.41875V16.9188M6.94625 8.41875H4.25828C3.70599 8.41875 3.25828 8.86647 3.25828 9.41875L3.25828 15.9063C3.25828 16.4586 3.70599 16.9063 4.25828 16.9063H14.4022C15.3278 16.9063 16.1325 16.2712 16.3475 15.371L17.7139 9.6511C17.864 9.02254 17.3875 8.41875 16.7413 8.41875H11.9256C11.9256 8.41875 13.0083 4.16875 12.0083 3.41875C11.0083 2.66875 9.75828 3.16875 9.50828 4.91875C9.25828 6.66875 6.94625 8.41875 6.94625 8.41875Z" stroke="#ABABAB" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <svg v-show="item.is_support == 'yes'" xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path d="M6.50828 8.41875V16.9188M6.94625 8.41875H4.25828C3.70599 8.41875 3.25828 8.86647 3.25828 9.41875L3.25828 15.9063C3.25828 16.4586 3.70599 16.9063 4.25828 16.9063H14.4022C15.3278 16.9063 16.1325 16.2712 16.3475 15.371L17.7139 9.6511C17.864 9.02254 17.3875 8.41875 16.7413 8.41875H11.9256C11.9256 8.41875 13.0083 4.16875 12.0083 3.41875C11.0083 2.66875 9.75828 3.16875 9.50828 4.91875C9.25828 6.66875 6.94625 8.41875 6.94625 8.41875Z" stroke="#FE484A" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>{{item.support_num>0?item.support_num: ''}}</span>
                </a>
              </div>

              <!-- 回复 -->
              <div class="comment_info_span comment_reply ">
                <a href="javascript:;"
                  class="dy_secRep22"
                  @click.stop.prevent="
                  srH5CallNativeMethodApp('comment_input',{
                    comment:item,
                    i:i,
                    j:ci == undefined ? -1 : ci,
                    kind:'comment',
                  })"
                  :id="'dy_secRep'+item.id"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                    <path d="M9.88235 12.0833H9.65588L9.49507 12.2428L8 13.7254L6.50493 12.2428L6.34412 12.0833H6.11765H2.5C1.42305 12.0833 0.55 11.2103 0.55 10.1333V3C0.55 1.92305 1.42305 1.05 2.5 1.05H13.5C14.577 1.05 15.45 1.92304 15.45 3V10.1333C15.45 11.2103 14.577 12.0833 13.5 12.0833H9.88235Z" stroke="#ABABAB" stroke-width="1.1"/>
                    <circle cx="4" cy="6.5" r="1" fill="#ABABAB"/>
                    <circle cx="8" cy="6.5" r="1" fill="#ABABAB"/>
                    <circle cx="12" cy="6.5" r="1" fill="#ABABAB"/>
                  </svg>
                </a>
              </div>

              <!-- 转发 -->
              <div class="comment_info_span comment_forward">
                <a href="javascript:;"
                  class="dy_secRep22 user_forward" 
                  :data-o_id="item.id" 
                  :data-o_kind="'comment'" 
                  @click.stop.prevent="srH5CallNativeMethodApp('comment_forward',{
                    data:item,
                    comment_origin_content:cdata ? cdata : '',
                  })"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 12.4276C0.5 10.6125 1.80688 5.75894 8.27137 5.2564C8.27137 4.41297 8.27137 2.38234 8.27137 1.4644C8.27137 1.2887 8.48168 1.19973 8.60909 1.32072L14.027 6.4658C14.2869 6.71258 14.298 7.12313 14.0518 7.38359L8.61672 13.1346C8.49246 13.2661 8.27137 13.1781 8.27137 12.9972V9.12674C8.27137 9.12674 3.43988 9.12674 0.778886 12.4885C0.650858 12.6502 0.5 12.7196 0.5 12.4276Z" stroke="#ABABAB"/>
                </svg>
                </a>
              </div>



            </div>





          </div>

          </div>


          <!--二级评论-->
          <div class="erji"
               v-if="item.sub_list && item.comment_num > 0"
          >
            <ul :id="'erji_shouqi'+item.id" >

              <c-box
                :id="item.id"
                :data="item.sub_list"
                :ckind="'second'"
                :ci="i"
                :cdata="item"
                :apptextSize="apptextSize"
                :teacher="teacher"
                :card_user="card_user"
                :card_user_info="card_user_info"
                :kind="kind"
              ></c-box>
              <!-- 用原评论数量去判断  -->

              <li class="erji_more" :id="'erji_more_js2'+item.id"
                v-show="item.sub_list && item.sub_list.length > 0 && item.old_comment_num > 7">
                <span class="js-more-second-comment more22" 
                  :data-id="item.id" :data-kind="kind"
                  @click.stop.prevent="srH5CallNativeMethodApp('comment_more',{
                    data:item
                  })"
                  >
                  共{{item.comment_num}}条回复
                  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 3L0 0L0 6L3.5 3Z" fill="#939393"/>
                  </svg>
                </span>
                
              </li>

              <li class="erji_more erji_more2" :id="'erji_more_js'+item.id"
                v-show="item.sub_list && item.sub_list.length > 0 && item.old_comment_num > 2 && item.old_comment_num <= 7">
                <span @click.stop.prevent="show_all(item.id,0)">
                  展开{{(item.comment_num - 2)}}条回复
                  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 3L0 0L0 6L3.5 3Z" fill="#939393"/>
                  </svg>
                </span>
              </li>

              <li class="erji_more less" :id="'erji_less_js'+item.id" :data-i="i"
                v-show="0">
                <span @click.stop.prevent="show_all(item.id,1,i)">
                  收起
                  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 3L0 0L0 6L3.5 3Z" fill="#939393"/>
                  </svg>
                </span>
              </li>

            </ul>

          </div>

        </div>

      </div>


    </li>

  </div>
</template>

<script>
import {strParse,rec_time} from "@/utils/strParse";
import userHomeApi from "@/api/user_home/index.js";
import "@/utils/flexible";
    export default {
      name: "c-box",
      data() {
        return {
          reqLoading: false, // 接口请求状态
        };
      },
      props: {
        id:String,//评论的id
        data: Array,//评论列表
        ckind:String,//是一级还是二级的评论
        ci:Number,//一级评论的数组索引
        cdata:Object,//一级评论数据

        kind:String,//内容kind
        teacher:Boolean,//是否是老师自己的内容（可对所有进行删除 拉黑）
        
        card_user_info: Object, // 页面信息

        apptextSize:String,//改变字号
        card_user: Object, // 老师信息
      },
      created(){
        
        
      },
      mounted(){
      },
      methods: {
        clickHandle(e,item,i,ci){
          console.log("点击了e",e);
          if (e.target.nodeName == "A") {
            console.log("点击了A标签");
            this.srH5CallNativeMethodApp('call_Native',{
              kind: 'person_page',//跳转页面
              id:item.role2 == 'liver'? item.r_l_id : item.r_id,
              o_kind:item.role2 == 'liver'? 'live_msg' : 'user_msg',
            })
          }
          else{
            console.log("点击了其他");
            this.srH5CallNativeMethodApp('comment_input',{
              comment:item,
              i:i,
              j:ci == undefined ? -1 : ci,
              kind:'comment',
            })
          }
        },
        srH5CallNativeMethodApp(kind,other){
          this.$srH5CallNativeMethodApp(kind,{
            ...other
          })
        },
        srBrowserMedia(url){
          this.$srBrowserMedia(0,[{"type":"image","img_url": url}]);
        },
        // 时间戳优化
        timeStampFn(item) {
          let time = item.rec_time || item.sort_time;
          if(!time) {
            return item.rec_time_desc;
          } else {
            return rec_time(time);
          }
        },
        //展开更多的a标签
        a_link(item){
          let content =  item.content;
          if(typeof strParse !=='undefined' && strParse) {
            content = strParse(content.replace(/\n/gi, '<br />'));
          }
          let {is_direct, r_name,role2,r_id,r_l_id} = item;
          if(is_direct == 'no'){

            if(role2 == 'user'){
              if(r_name && r_id){
                content = `回复<a  href="javascript:;" class="js-page-person2">@${r_name}</a>:${content}`;
              }
            }
            else if(role2 == 'liver'){
              if(r_name && r_l_id){
                content = `回复<a href="javascript:;"  class="js-page-person2">@${r_name}</a>:${content}`;
              }
            }

          }
          return content;
        },
        // 点赞
        async sup(id,i, is_support) {
            if(this.reqLoading) {
                return
            }
            this.reqLoading = true;
            //点赞功能
            let type = 'support'
            if (is_support != "yes") {
                // 点赞
                this.$set(this.data[i], 'is_support', 'yes');
                this.$set(this.data[i], 'support_num', this.data[i].support_num * 1 + 1);
                is_support = 'yes';
            } else {
                // 取消点赞
                type = 'cancel_support';
                this.$set(this.data[i], 'is_support', 'no');
                this.$set(this.data[i], 'support_num', this.data[i].support_num * 1 - 1);
                is_support = 'no';
            }

            let res = await userHomeApi.setAttitude({
                act: "publish",
                kind: "comment",
                type,
                id
            })

            if(res.rslt == 'succ') {
                localStorage['comment'+id] = is_support;
            }

            this.reqLoading = false;
        },
        //二级评论展开收起
        show_all(id,is_show,i){
          if(is_show == 1){
            //二级评论收起

            //收起时重新渲染一下
            this.$emit('ShowListData',i);

            this.$nextTick(()=>{
              setTimeout(() => {
              let len = $(`#erji_shouqi${id} .dy_secItem22`).length;
              for(let i = 4;i<=len;i++){
                $(`#erji_shouqi${id} .dy_secItem22:nth-child(${i})`).addClass('second_none');
              }
              $(`#erji_shouqi${id} .second_none`).hide();
              $(`#erji_more_js${id}`).show();
              $(`#erji_less_js${id}`).hide();
            }, 0);
            })
            


          }
          else{
            //二级评论展开
            $(`#erji_shouqi${id} .second_none`).show();
            $(`#erji_less_js${id}`).show();
            $(`#erji_more_js${id}`).hide();
            this.$nextTick(function () {
              // 展开收起全文
              window.expandComment();
            });
          }

        },
        //展开收起全文
        expand(id,need){
          console.log('??')
          if(need == 1){
            $(`#expand_full_js_sq${id}${this.ckind}`).show();
            $(`#expand_full_js${id}${this.ckind}`).hide();
            $(`#comment_content${id}${this.ckind}`).removeClass('content_css_less').addClass('content_css_all');
          }
          else{
            $(`#expand_full_js_sq${id}${this.ckind}`).hide();
            $(`#expand_full_js${id}${this.ckind}`).show();
            $(`#comment_content${id}${this.ckind}`).removeClass('content_css_all').addClass('content_css_less');
          }
        },

      },
    }
</script>

<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
  .dy_secItem22{
    //border-top: 1px solid #EDF0F5;
    padding-top: rem2(20px);
    padding-left: 0px;
    float: none;
    margin: 0;
    background: inherit;
    box-sizing: border-box;

    .dy_secItem22 {
      padding: rem2(10px);
    }

    .sec_wrap22 {
      display: flex;
      width: 100%;
      .second_reply_img22 {
        margin: 0 rem2(10px) 0 0;
        width: rem2(32px);
        height: rem2(32px);
        border-radius: 50%;
        flex-shrink: 0;
        >img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .anthor_zan{
        display: flex;
        padding: rem2(4px) rem2(6px);
        justify-content: center;
        align-items: center;
        max-width: max-content;
        margin: rem2(6px) 0;
        border-radius: rem2(4px);
        background: $a-grey-f6;
        color: #939393;
        font-size: rem2(12px);
        line-height: normal;
      }
      .second_reply_right22{
        flex: 1;

        .dy_secComWrap {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: rem2(7px);
          
          .dy_secCom22{
            line-height: rem2(20px);
            display: flex;
            align-items: center;
            >a{  
              color: #636363;
              font-size: rem2(14px);
              line-height: rem2(17px);
              margin-right: rem2(5px);
            }
            >em{
              background-size: rem2(14px);
              width: rem2(14px);
              height: rem2(14px);
              display: inline-block;
              margin: 0 rem2(2px) 0 0;
              position: unset;
              float: none;
              margin-right: rem2(5px);
            }
            >span {
              &.card_author {
                display: flex;
                align-items: center;
                justify-content: center;
                width: rem2(27.5px);
                height: rem2(15px);
                flex-shrink: 0;
                border-radius: rem2(8px);
                border: rem2(.5px) solid #0F86D3;
                color: #1D88D0;
                font-size: rem2(10.5px);
                margin-right: rem2(5px);
              }
              &.is_user_set_top{
                display: flex;
                width: 53px;
                height: 18px;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
                color: #FF453D;
                text-align: center;
                font-size: 11px;
                border-radius: 2.5px;
                background: #FFE8E8;
              }
            }
            .dy_secCom_span{
              color: #999;
            }

            .dy_secTim22_ip{
              line-height: rem2(21px);
              font-size: rem2(12px);
              color: #939393;
              margin-right: rem2(5px);
              &.hot{
                color: #F68532;
              }
            }

          }

        }
        .content_css{ 
          word-break: break-all;
          height: auto;
          line-height: 0;
          position: relative;

          line-height: 20px;
          font-size: 15px;

          &.content_css_all{
            height: auto;
            max-height: unset;
            position: relative;
          }
          &.content_css_less{
            max-height: 120px;
            overflow: hidden;
            position: relative;
            &.small, &.litter {
              max-height: 108px;
            }

            &.middle {
              max-height: 120px;
            }

            &.large {
              max-height: 120px;
            }

            &.xlarge {
              max-height: 144px;
            }

            &.xxlarge {
              max-height: 168px;
            }

            &.big {
              max-height: 132px;
            }
          }

          &.small, &.litter {
            font-size: 13px;
            line-height: 18px;
          }

          &.middle {
            font-size: 17px;
            line-height: 20px;
          }

          &.large {
            font-size: 17px;
            line-height: 20px;
          }

          &.xlarge {
            font-size: 21px;
            line-height: 24.5px;
          }

          &.xxlarge {
            font-size: 25px;
            line-height: 29px;
          }

          &.big {
            font-size: 19px;
            line-height: 22px;
          }


        } 
        



        .expand_full22{
          display: inline-flex;
          color: #507DAF;
          margin-left: rem2(2px);
        }

        .expand_full_js{
          position: absolute;
          right: 0px;
          bottom: 0px;
          background: rgb(255, 255, 255);
        }

        .dy_secTim22{
          color: $a-normal;
        }
        .cmtImg{
          color: #1D88D0!important;
          background: url(https://cdncos.aigupiao.com/assets/pc/img/cmt-img.png) no-repeat;
          background-position: 0 center;
          background-size: rem2(15px) rem2(12px);
          padding-left: rem2(18px);
          position: relative;
          margin-left: rem2(3px);
        }
        .dy_second_manage{
          display: flex;
          align-items: center;
          position: relative;

          flex-direction: row-reverse;
          >svg{
            width: rem2(15px);;
            height: rem2(3px);;
            flex-shrink: 0;
          }



          .comment_info_reply22 {
            position: relative;
            

            a {
              color: #666;
              display: flex;
              align-items: center;
              svg {
                width: rem2(20px);
                height: rem2(20px);
                margin-right: rem2(2px);
              }
              span{
                color: #ABABAB;
                font-size: rem2(12px);
              }
            }
            .done{
              >span{
                color: #f04748;
              }
            }
          }

          .comment_info_span {
            padding-right: rem2(23px);
            position: relative;

            &:first-of-type {
              &:before{
                display: none;
              }
            }

            &.comment_reply{
              
              padding-left: rem2(5px);
            }

            a {
              display: flex;

              svg {
                width:  rem2(16px);
                height: rem2(14px);
                flex-shrink: 0;
              }
            }

            &.comment_forward {
              margin: 0 !important;
            }


          }
        }

      }

    }
  }
  .second_none{
    display: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .erji{
    margin-top: rem2(12px);
    border-radius: rem2(10px);
    overflow: hidden;

    .sec_wrap22{

      .second_reply_right22 {
        .expand_full22{
          background: $a-grey-f6;
        }
      }

      .anthor_zan{
        background: $a-white;
      }

      

      .second_reply_img22{
        display: flex;
        width: rem2(20px);
        height: rem2(20px);
        margin-right: rem2(6px);
      }
    }

    
    .erji_more{

      padding: 0 rem2(10px) rem2(10px) rem2(10px);
      display: flex;
      align-items: center;
      line-height: rem2(17px);
      color: #939393;
      font-size: rem2(12px);
      

      >span{
        border-radius: rem2(12px);
        width: max-content;
        padding: rem2(3px) rem2(9px);
        background: $a-white;
        padding-right: rem2(4px);
        display: inline-block;
        
      }

      svg{
        width:  rem2(12px);
        height: rem2(7px);
      }
      .more22{
      }
    }

    .erji_more2{
      svg{
        transform: rotate(90deg);
      }
      
    }
    .less{
      svg{
        transform: rotate(270deg);
      }
    }
    >ul{
      background: $a-grey-f6;
    }

    .sec_wrap22 {
      .second_reply_right22  {


      }
    }

    

     
    
  }

  .first_li_none_border{
    
    .dy_secItem22:first-of-type{
      border-top: none;
    }
  }


  


</style>
<style>
  .dy_secTim22 >a{
    color: #2F65BB;
  }
</style>
